import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import EbookLP2 from "../../components/ebooklp2";
import BgImg1 from "../../../images/landing/bg_ebook.jpg";
import { StaticImage } from "gatsby-plugin-image";

const EbookLanding = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <section
        className="p-100 ebook_lp_secion"
        style={{ backgroundImage: `url(${BgImg1})` }}
      >
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
              <h4>
                Top 10 Mobile App Development Trends to Watch Out For in 2024
              </h4>
              <p>
                Stay ahead in the fast-changing world of mobile app development
                with our comprehensive eBook. Explore the latest trends shaping
                the industry, from innovative technologies to user experience
                enhancements. Equip yourself with the knowledge to create
                cutting-edge and successful mobile applications!
              </p>
              <div
                className="btn_download"
                onClick={handleShow}
                style={{ background: "rgb(240, 121, 45)" }}
              >
                GET MY COPY
              </div>
            </Col>
            <Col
              xs={12}
              md={6}
              lg={7}
              xl={7}
              xxl={7}
              className="my-auto text-center"
            >
              <StaticImage
                src="../../../images/locationgcc/services/ebook_ae.webp"
                alt="mobile app development company"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={766}
                height={679}
              />
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="modal_forms">
          <EbookLP2 setShow={setShow} GCC="yes" />
        </div>
      </Modal>
    </>
  );
};

export default EbookLanding;
